import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, TouchableOpacity, ViewStyle } from 'react-native';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils';

interface IconProps {
  color: string;
  width: number;
  height: number;
}

interface IParentProps {
  Icon: React.FC<IconProps>;
  text: string;
  iconColor: string;
  rightButton?: boolean;
  onPress?: () => void;
  subText?: string;
  iconSize?: number;
}

const StudioWorkoutStartingHeaderButton: FunctionComponent<IParentProps> = (
  {
    Icon,
    text,
    iconColor,
    subText,
    onPress,
    rightButton = false,
    iconSize = defaultScale(20),
  },
) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={!onPress}
      style={[
        styles.buttonContainer,
        rightButton ? { marginLeft: defaultScale(5) } : { marginRight: defaultScale(5) },
      ]}
    >
      <Icon color={iconColor} width={iconSize} height={iconSize} />
      <Text style={styles.mainText}>{text}</Text>
      {subText && (<Text style={styles.subText}>{subText}</Text>)}
    </TouchableOpacity>
  );
};

export default StudioWorkoutStartingHeaderButton;

const styles = StyleSheet.create({
  buttonContainer: {
    borderWidth: 1,
    borderColor: Theme.GREY_MEDIUM_LIGHT,
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    paddingVertical: defaultScale(20),
    marginTop: defaultScale(15),
    borderRadius: defaultScale(5),
  },
  mainText: {
    marginTop: defaultScale(5),
    ...Theme.textStyle.bodyCopyBold,
  },
  subText: {
    ...Theme.textStyle.small,
  },
});
